import React, { useMemo } from 'react';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';

import KogCheckbox from '@/main/components/shared/checkbox/kogCheckbox';
import { isNullUndefined } from '@/main/services/utils';

import { IItemFormRequoteSupplierOrdered, IRequoteOrderedForm } from '../modalRequoteOrderedPart';
import RowItemRequoteOrdered from '../rowItemRequoteOrdered/rowItemRequoteOrdered';
import * as S from './styles';

interface IRowSupplierRequoteOrderedProps {
  supplier: IItemFormRequoteSupplierOrdered;
  indexSupplier: number;
}
function RowSupplierRequoteOrdered({
  supplier,
  indexSupplier
}: IRowSupplierRequoteOrderedProps) {
  const {
    control,
    setValue
  } = useFormContext<IRequoteOrderedForm>();

  const {
    fields,
    append
  } = useFieldArray<IRequoteOrderedForm>({ control, name: `suppliers.${indexSupplier}.items` });
  const watcherFields = useWatch({ control, name: `suppliers.${indexSupplier}.items` });
  const controlledFields = watcherFields.map((field, index) => {
    return {
      ...field,
    };
  });

  const allCheckboxesSelected = useMemo(() => {
    if (isNullUndefined(controlledFields)) return false;
    return controlledFields.every(item => item.isSelected);
  }, [JSON.stringify(controlledFields)])

  function handleToggleCheckboxAll() {
    const isAllCheckboxesSelected = controlledFields.every(item => item.isSelected);
    controlledFields.forEach((item, index) => {
      setValue(`suppliers.${indexSupplier}.items.${index}.isSelected`, !isAllCheckboxesSelected);
    });
  }

  return (
    <S.Container>
      <S.HeaderSupplier
        onClick={() => handleToggleCheckboxAll()}
      >
        <S.TitleSupplier title={supplier.supplierName}>{supplier.supplierName}</S.TitleSupplier>
        <KogCheckbox
          checked={allCheckboxesSelected}
          value={allCheckboxesSelected}
          onChange={() => {
            handleToggleCheckboxAll()
          }}
        />
      </S.HeaderSupplier>
      <S.BodySupplier>
        {controlledFields.map((item, index) => (
          <RowItemRequoteOrdered
            key={item.procurementSupplierItemGuid}
            index={index}
            part={item}
            indexSupplier={indexSupplier}
          />
        ))}
      </S.BodySupplier>
    </S.Container>
  )
}

export default RowSupplierRequoteOrdered;